module.exports = __webpack_public_path__ + "static/media/sso.66e45f4d.png";